// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"331":"5de4c348","443":"389e3432","455":"9eb6c8a6","715":"61413069"}[chunkId] + ".css";
};